export const url = {
  frontend: 'https://app.earthideal.com',
  backend: 'https://app.earthideal.com:2999',

  //frontend: 'http://localhost:3000',
  //backend: 'http://localhost:2999',
  stripe_key: 'pk_live_o2riQdZlnOHZHwNDUqlOypmF007FS0Aklq'
};

//export const frontendURl = 'http://localhost:3000';
//export const apiURl = 'http://localhost:2999';
export const frontendURl = 'https://app.earthideal.com';
export const apiURl = 'https://app.earthideal.com:2999';
export const haulcheckURl = 'https://haulcheck.earthideal.com';
export const assuredURL = 'https://assureddisposal.earthideal.com';
export const assuredAPIURL = 'https://assureddisposal.earthideal.com:2997';
